import { FieldInstance } from '@workflow/class/field.service';
import { PrimitiveType, Validations } from '../../class/workflow.type';

/**
 * Convert validation logic function to validation object
 * This is a temporary function and will be removed when the new implementation of mask is pushed.
 */
export const getValidationObject = (field: FieldInstance): Validations => {
  const validation = {
    allowedDecimals: getValidationValue(field, 'allowedDecimals'),
    fixedDecimals: getValidationValue(field, 'fixedDecimals'),
    max: getValidationValue(field, 'max'),
    maxLength: getValidationValue(field, 'maxLength'),
    min: getValidationValue(field, 'min')
  } as Validations;

  return validation;
};

/** get validation value */
const getValidationValue = (field: FieldInstance, validationName: string): PrimitiveType => {
  const validation = field.hasValidation(validationName);
  return validation ? validation[0] : null;
};
